import type { LucideIcon } from "lucide-react"
import {
  CalendarDays,
  FileText,
  FolderTree,
  Layers,
  LayoutDashboard,
  ListChecks,
  PenSquare,
  Radar,
  SearchCheck,
  Settings,
  Sparkles,
  Tag,
  Users,
} from "lucide-react"

export interface NavItem {
  title: string
  href: string
  icon: LucideIcon
  /** Extra words the command palette matches on. */
  keywords?: string[]
  /** Exact match only (used for the dashboard index). */
  end?: boolean
}

export interface NavGroup {
  label: string
  items: NavItem[]
}

export interface QuickAction {
  title: string
  href: string
  icon: LucideIcon
  keywords?: string[]
}

/** Single source of truth for the sidebar and the command palette. */
export const navigation: NavGroup[] = [
  {
    label: "Overview",
    items: [{ title: "Dashboard", href: "/dashboard", icon: LayoutDashboard, end: true, keywords: ["home", "stats"] }],
  },
  {
    label: "Content",
    items: [
      { title: "Posts", href: "/dashboard/posts", icon: FileText, keywords: ["articles", "drafts"] },
      { title: "Trend Explorer", href: "/dashboard/trends", icon: Radar, keywords: ["trends", "topics", "discover", "research", "trending", "ideas"] },
      {
        title: "AI Generations",
        href: "/dashboard/ai-generations",
        icon: ListChecks,
        keywords: ["ai", "studio", "generate", "review", "drafts", "queue", "logs", "publish", "autopilot", "history"],
      },
      {
        title: "Calendar",
        href: "/dashboard/calendar",
        icon: CalendarDays,
        keywords: ["schedule", "scheduled", "queue", "runway", "content calendar", "planner", "upcoming"],
      },
    ],
  },
  {
    label: "Taxonomy",
    items: [
      { title: "Categories", href: "/dashboard/categories", icon: FolderTree, keywords: ["sections"] },
      { title: "Subcategories", href: "/dashboard/subcategories", icon: Layers },
      { title: "Tags", href: "/dashboard/tags", icon: Tag, keywords: ["labels"] },
    ],
  },
  {
    label: "People",
    items: [{ title: "Authors", href: "/dashboard/authors", icon: Users, keywords: ["writers", "team"] }],
  },
  {
    label: "System",
    items: [
      { title: "SEO", href: "/dashboard/seo", icon: SearchCheck, keywords: ["search", "keywords", "meta", "sitemap", "google"] },
      { title: "Settings", href: "/dashboard/settings", icon: Settings, keywords: ["api keys", "scheduler", "config"] },
    ],
  },
]

export const quickActions: QuickAction[] = [
  { title: "Write a new post", href: "/dashboard/posts/new", icon: PenSquare, keywords: ["create", "article"] },
  { title: "New AI post", href: "/dashboard/ai-generations/new", icon: Sparkles, keywords: ["ai", "generate", "create", "write"] },
  { title: "Find trending topics", href: "/dashboard/trends", icon: Radar, keywords: ["trends", "discover", "ideas"] },
  { title: "Create a category", href: "/dashboard/categories/new", icon: FolderTree, keywords: ["add"] },
  { title: "Create a subcategory", href: "/dashboard/subcategories/new", icon: Layers, keywords: ["add"] },
  { title: "Create a tag", href: "/dashboard/tags/new", icon: Tag, keywords: ["add", "label"] },
  { title: "Add an author", href: "/dashboard/authors/new", icon: Users, keywords: ["writer", "create"] },
]
